const prepareAffiliateMember = (affiliateMember) => {
  return {
    'affiliate_member': {
      name: affiliateMember.name,
      linked_at: affiliateMember.linked_at
    },
  }
}

const prepareAffiliateMemberDetail = (affiliateMemberDetail) => {
  return {
    'affiliate_member_details_params': {
      owner: affiliateMemberDetail?.owner,
      phone_number: affiliateMemberDetail?.phone_number,
      email: affiliateMemberDetail?.email,
      website: affiliateMemberDetail?.website,
      member_since: affiliateMemberDetail?.member_since,
      organization_name: affiliateMemberDetail?.organization_name,
      statuses: affiliateMemberDetail?.statuses,
      crra: affiliateMemberDetail?.crra,
      provider_id: affiliateMemberDetail?.provider_id,
      legal_entity_name: affiliateMemberDetail?.legal_entity_name,
      business_entity_name: affiliateMemberDetail?.business_entity_name
    }
  };
};

const prepareAffiliateMemberAddress = (affiliateMemberAddress) => {
  return {
    'affiliate_member_address_params': {
      street: affiliateMemberAddress?.street,
      state: affiliateMemberAddress?.state,
      city: affiliateMemberAddress?.city,
      zipcode: affiliateMemberAddress?.zipcode
    }
  }
}

export {
  prepareAffiliateMember,
  prepareAffiliateMemberDetail,
  prepareAffiliateMemberAddress
};
